module.exports = __webpack_public_path__ + "static/main2-beea5c3d5b419e245cbff9baedb49885.png";